import noop from 'utils/noop';
import { Preset } from './ColorPicker.styled';

// type Props = {
//   /** Additional class name. */
//   className: string,
//   /** Hex string value of color */
//   color: string,
//   /** Callback function when preset is clicked. */
//   onClick: (props: {}) => {},
//   /** If color is currently selected. */
//   selected: boolean,
// };

const ColorPreset = ({ color, onClick = noop, selected }) => {
  const handleClick = (e) => {
    onClick(e, { color, onClick, selected });
  };

  return (
    <Preset
      data-test="color-preset"
      onClick={handleClick}
      style={{ background: color }}
      data-selected={selected}
    />
  );
};

export default ColorPreset;
